import backFuture from './assets/back-to-the-future.jpg';
import breakBad from './assets/breaking-bad.jpg';
import bucky from './assets/bucky.jpg';
import eternelle from './assets/eternelle.jpg';
import eveJikan from './assets/eve-no-jikan.jpg';
import eveJikanLarge from './assets/eve-no-jikan-wide.png';
import findingNemo from './assets/finding-nemo.jpg';
import groundhogDay from './assets/groundhog-day.jpg';
import hunterHunter from './assets/hunter-hunter.jpg';
import imitationGame from './assets/imitation-game.jpg';
import laputa from './assets/laputa.jpg';
import summerWars from './assets/summer-wars.jpg';
import travelers from './assets/travelers.jpg';
import tropaElite from './assets/tropa-de-elite.jpg';
const movies = [
    {
        id: 1,
        nome: 'De volta para o futuro',
        isSeries: false,
        episodios: {},
        stars: 5,
        descricao: "Marty McFly, um adolescente de uma pequena cidade californiana, é transportado paraa década de 1950 quando a experiência do excêntrico cientista Doc Brown dá errado. Viajando no tempo em um carro modificado, Marty conhece versões jovens de seus pais e precisa fazer com que eles se apaixonem, ou então ele deixará de existir. Para complicar, Marty precisa voltar para casa a tempo de salvar o cientista.",
        poster: backFuture,
        large: backFuture
    },
    {
        id: 2,
        nome: 'Breaking Bad',
        isSeries: true,
        episodios: {
            temp1: [
                'Piloto',
                'O gato está no saco..',
                '..E o saco está no rio',
                'Homem de câncer',
                'Matéria cinzenta',
                'Punhado louco de nada',
                'Um acordo simples'
            ]
        },
        stars: 4,
        descricao: "Breaking Bad é uma série de televisão americana criada e produzida por Vince Gilligan. Ela retrata a vida do químico Walter White, um homem brilhante frustrado em dar aulas para adolescentes do ensino médio enquanto lida com um filho sofrendo de paralisia cerebral, uma esposa grávida e dívidas intermináveis.",
        poster: breakBad,
        large: breakBad
    },
    {
        id: 3,
        nome: 'Bucky',
        isSeries: true,
        episodios: {
            temp1:[
                'Sonho em governar o mundo',
                'A outra grande criança',
                'O ataque a cidade dos porcos',
                'O monstro da rocha',
                'A terceira grande crianla',
                'O orgulho é a prova do meu sonho',
                'Aperfeiçoamento da técnica',
                'O roubo do castelo',
                'A grande criança Ali Baba',
                'A Vitória de um monstro'
            ]
        },
        stars: 3,
        descricao: 'Em algum lugar em uma dimensão desconhecida, há uma misteriosa terra chamada doze mundos. Lá, humanos, monstros e Espíritos coexistem em harmonia. Todas as vidas são protegidas pela princesa da "Torre Pontiaguda", localizada no "Mundo Zero".',
        poster: bucky,
        large: bucky
    },
    {
        id: 4,
        nome: 'Eternelle',
        isSeries: true,
        episodios: {
            temp1:[
                'Episódio 1',
                'Episódio 2',
                'Episódio 3',
                'Episódio 4',
                'Episódio 5',
                'Episódio 6',
            ]
        },
        stars: 2,
        descricao: 'Uma mulher misteriosa acorda no hospital. Ela não tem nenhum documento de identidade e perdeu a memória. Ela logo desenvolve poderes sobrenaturais.',
        poster: eternelle,
        large: eternelle,
    },
    {
        id: 5,
        nome: 'Eve no Jikan',
        isSeries: true,
        episodios: {
            temp1: [
                'Akiko: Tempo de Eve',
                'Sammy: Companheiros de Eve',
                'Koji e Rina: Amantes de Eve',
                'Sem nome: Boneca de Eve',
                'Chie e Shimei: Melodia de Eve',
                'Masaki: Amigos de Eve'
            ]
        },
        stars: 4,
        descricao: 'Eve no Jikan se passa em um futuro onde a mecatrônica atingiu um nível de perfeição incrível capaz de fabricar robôs praticamente idênticos a seres humanos, com a diferença de que eles são usados apenas como meras ferramentas. A trama se desenrola quando o dono de um desses andróides Rikuo percebe que seu andróide Sammy está agindo estranho. Tentando descobrir a causa, ele acaba encontrando um "cafe", chamado Eve no Jikan, cuja regra era que não houvesse descriminação entre humano e andróide',
        poster: eveJikan,
        large: eveJikanLarge
    },
    {
        id: 6,
        nome: 'Procurando Nemo',
        isSeries: false,
        episodios: {},
        stars: 3,
        descricao: 'Em seu primeiro dia de aula, esquecendo os conselhos do pai superprotetor, Nemo é capturado por um mergulhador e acaba no aquário de um dentista. Enquanto Nemo tenta bolar um plano para escapar, seu pai cruza o oceano para resgatá-lo.',
        poster: findingNemo,
        large: findingNemo
    },
    {
        id: 7,
        nome: 'Feitiço do tempo',
        isSeries: false,
        episodios: {},
        stars: 4,
        descricao: 'Phil, um arrogante meteorologista de um canal de televisão, fica preso em uma espécie de túnel do tempo, condenado a reviver indefinidamente o mesmo dia até que mude suas atitudes.',
        poster: groundhogDay,
        large: groundhogDay
    },
    {
        id: 8,
        nome: 'Hunter x Hunter',
        isSeries: true,
        episodios: {
            temp1:[
                'Partida x e x Amigos',
                'Teste x dos x Testes',
                'Rivais x Pela x Sobrevivência',
                'Esperança x e x Ambição',
                'Hisoka x é x Sorrateiro',
                'Um x Desafio x Surpreendente',
                'Batalha x no x Dirigível',
                'Voto x da x Maioria',
                'Cuidado x com x os x Prisioneiros',
                'Truque x para x um Truque',
                'Problemas x com x a Aposta',
                'Último Teste x de x Determinação'

            ]
        },
        stars: 5,
        descricao: 'A série conta a história de Gon Freecss, um garoto de 12 anos que pretende se tornar um Hunter, um caçador de tesouros, lugares perdidos e criaturas estranhas.',
        poster: hunterHunter,
        large: hunterHunter
    },
    {
        id: 9,
        nome: 'Jogo da imitação',
        isSeries: false,
        episodios: {},
        stars: 4,
        descricao: 'Em 1939, a recém-criada agência de inteligência britânica MI6 recruta Alan Turing, um aluno da Universidade de Cambridge, para entender códigos nazistas, incluindo o "Enigma", que criptógrafos acreditavam ser inquebrável. A equipe de Turing, incluindo Joan Clarke, analisa as mensagens de "Enigma", enquanto ele constrói uma máquina para decifrá-las.',
        poster: imitationGame,
        large: imitationGame
    },
    {
        id: 10,
        nome: 'O Castelo no céu',
        isSeries: false,
        episodios: {},
        stars: 5,
        descricao: 'A jovem órfã Sheeta e seu sequestrador, coronel Muska, estão voando para uma prisão militar quando sua aeronave é atacada por uma gangue de piratas aéreos liderados por Dola. Escapando da colisão no ar através de um cristal mágico em seu pescoço, Sheeta conhece o também órfao Pazu. Juntos, tentam descobrir a cidade mística flutuante de Laputa, enquanto são perseguidos por Muska e os piratas, que cobiçam o tesouro da cidade.',
        poster: laputa,
        large: laputa
    },
    {
        id: 11,
        nome: 'Summer Wars',
        isSeries: false,
        episodios: {},
        stars: 3,
        descricao: 'Um adolescente gênio da matemática soluciona uma equação complexa. O problema é que ao fazer isso ele coloca a inteligência artificial do mundo virtual em posição para destruir o planeta.',
        poster: summerWars,
        large: summerWars
    },
    {
        id: 12,
        nome: 'Travelers',
        isSeries: true,
        episodios: {
            temp1:[
                'Piloto',
                'Protocolo 6',
                'Aleksander',
                'Hall',
                'Sala 101',
                'Helios 685',
                'Protocolo 5',
                'Donner',
                'Bishop',
                'Kathryn',
                'Marcy',
                'Grace'
            ]
        },
        stars: 4,
        descricao: 'Centenas de anos no futuro, os humanos sobreviventes descobrem como enviar a consciência humana de volta no tempo, para dentro de pessoas que vivem no século XXI. Esses viajantes assumem as vidas de outras pessoas, enquanto tentam salvar a humanidade de um futuro terrível.',
        poster: travelers,
        large: travelers
    },
    {
        id: 13,
        nome: 'Tropa de Elite',
        isSeries: false,
        episodios: {},
        stars: 5,
        descricao: 'Nascimento, capitão da Tropa de Elite do Rio de Janeiro, é designado para chefiar uma das equipes que tem como missão apaziguar o Morro do Turano. Ele precisa cumprir as ordens enquanto procura por um substituto para ficar em seu lugar. Em meio a um tiroteio, Nascimento e sua equipe resgatam Neto e Matias, dois aspirantes a oficiais da PM. Ansiosos para entrar em ação e impressionados com a eficiência de seus salvadores, os dois se candidatam ao curso de formação da Tropa de Elite',
        poster: tropaElite,
        large: tropaElite
    }
]
export default movies